export const selectApp = (state) => state.app;

export const selectAppName = (state) => state.app.name;

export const selectSideMenuFullWidth = (state) => state.app.sideMenuFullWidth;
